import { Route } from 'react-router-dom';
import LayoutOpen from "../components/layout/LayoutOpen";

// Auth
import Login from '../pages/auth/Login';
import NotApproved from "../pages/auth/NotApproved";
import CreateAccount from "../pages/auth/CreateAccount";
import Register from "../pages/auth/Register";
import RegisterInvitation from "../pages/auth/RegisterInvitation";

// Onboarding
import OnboardingFlow from "../pages/onboarding/OnboardingFlow";

// Open
import LiveReportOpen from "../pages/open/LiveReportOpen";
import LiveReportOpen2 from "../pages/open/LiveReportOpen2";
import ImpactPageOpen from "../pages/open/ImpactPageOpen";
import QuestionnaireOpen from "../pages/open/QuestionnaireOpen";
import Impactplan from "../pages/open/Impactplan";
import EventOpen from "../components/open/EventOpen";
import IntakeFormOpen from "../components/open/intakeForms/IntakeFormOpen";
import StorytellingOpen from "../pages/open/StorytellingOpen";
import { client } from '../hooks/Client';

/**
 * Since React Router v5 does not support component-nested <Switch> / <Route> components, 
 * you can use this to insert these public routes into the mobile/desktop routers. 
 */
const getPublicRoutes = () => [
  // Auth routes
  <Route key="login" path="/login">
    <Login />
  </Route>,
  <Route key="not-approved" path={`/${client}/NotApproved`}>
    <NotApproved />
  </Route>,
  <Route key="register" path={`/:id/Register`}>
    <Register />
  </Route>,
  <Route key="create-account" path={`/createAccount`}>
    <CreateAccount />
  </Route>,
  <Route key="register-invitation" path={`/${client}/RegisterInvitation`}>
    <RegisterInvitation />
  </Route>,
  <Route key="signup" path="/signup/:step?">
    <OnboardingFlow />
  </Route>,

  // Open routes
  <Route key="livereport-open" path={`/${client}/livereportopen`}>
    <LayoutOpen>
      <LiveReportOpen />
    </LayoutOpen>
  </Route>,
  <Route key="livereport-open-2" path={`/${client}/livereportopen2`}>
    <LiveReportOpen2 />
  </Route>,
  <Route key="impact-open" path={`/${client}/impactopen`}>
    <ImpactPageOpen />
  </Route>,
  <Route key="questionnaire-open" path={`/${client}/questionnaireopen`}>
    <LayoutOpen>
      <QuestionnaireOpen />
    </LayoutOpen>
  </Route>,
  <Route key="impactplan" path={`/impactplan`}>
    <LayoutOpen>
      <Impactplan />
    </LayoutOpen>
  </Route>,
  <Route key="event-open" path={`/${client}/eventopen`}>
    <LayoutOpen>
      <EventOpen />
    </LayoutOpen>
  </Route>,
  <Route key="intakeform-open" path={`/${client}/intakeformopen`}>
    <LayoutOpen>
      <IntakeFormOpen />
    </LayoutOpen>
  </Route>,
  // Bewust zonder LayoutOpen: Topbar leest Firestore met de organisatie uit de
  // url, en deze pagina krijgt alles via de server (ADR-022).
  <Route key="storytelling-open" path={`/${client}/storytellingopen`}>
    <StorytellingOpen />
  </Route>,
];

export default getPublicRoutes;
